import { apiFetch, ensureCsrf, setCsrfToken } from "@contractor-quoting/api-client";
import { clearChatDraft, saveChatDraft } from "./chat-draft.js";
import { clearDraftPrompt, readDraftPromptId, saveDraftPrompt } from "./project-intake.js";

interface CustomerProjectResult {
  projectId: string;
}

export async function startAnonymousStructuredProject(
  contractorSlug: string,
  description: string,
): Promise<string> {
  saveDraftPrompt(description);
  const created = await apiFetch<{ csrfToken: string }>("/v2/quote/intakes", {
    method: "POST",
    body: JSON.stringify({ contractorSlug, description }),
  });
  setCsrfToken(created.csrfToken);
  return `/chat/${encodeURIComponent(contractorSlug)}?intake=1`;
}

export async function startCustomerStructuredProject(
  contractorSlug: string,
  description: string,
): Promise<string> {
  saveDraftPrompt(description);
  const clientMessageId = readDraftPromptId();
  await ensureCsrf();
  const created = await apiFetch<CustomerProjectResult>("/v2/customer/projects", {
    method: "POST",
    headers: { "Idempotency-Key": clientMessageId },
    body: JSON.stringify({ contractorSlug, description }),
  });
  saveChatDraft(created.projectId, [], description, clientMessageId);
  try {
    await apiFetch(`/v1/customer/projects/${created.projectId}/chat/session`, {
      method: "POST",
    });
    await apiFetch(`/v1/customer/projects/${created.projectId}/chat/messages`, {
      method: "POST",
      body: JSON.stringify({ message: description, clientMessageId }),
    });
    clearChatDraft(created.projectId);
    clearDraftPrompt();
  } catch {
    // The project page hydrates server state and retains the local draft for a safe retry.
  }
  return created.projectId;
}
